import { z } from "zod";

export const PASSWORD_MIN = 12;
export const PASSWORD_MAX = 128;

/** zod rule whose messages are i18n keys. */
export const passwordRule = z
  .string()
  .min(PASSWORD_MIN, "auth.passwordHint")
  .max(PASSWORD_MAX, "auth.passwordTooLong");

export type Strength = "weak" | "ok" | "strong";

export function passwordStrength(pw: string): Strength {
  if (pw.length < PASSWORD_MIN) return "weak";
  const classes = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^A-Za-z0-9]/].filter((r) => r.test(pw)).length;
  return pw.length >= 16 || classes >= 3 ? "strong" : "ok";
}
